import { DataGridPro } from "@mui/x-data-grid-pro";

const ReportTable = ({ data, columns, loading, toolbar: Toolbar }) => {
  
  return (
    <DataGridPro
      rows={data}
      columns={columns}
      loading={loading}
      autoHeight
      slots={{ toolbar: Toolbar }}
      disableColumnResize
      disableColumnMenu
      hideFooter
      sx={{
        border: 'none',
        '& .MuiDataGrid-cell': {
          borderBottom: 'none',
        },
        '& .MuiDataGrid-columnHeaders': {
          borderBottom: 'none',
          backgroundColor: 'white !important',
        },
        '& .MuiDataGrid-columnHeader': {
          backgroundColor: 'white !important',
        },
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '& .MuiDataGrid-filler': {
          display: 'none',
        },
        '& .MuiDataGrid-scrollbar--horizontal': {
          display: 'none',
        },
      }}
    />
  );
};

export default ReportTable;
